// Wird von Vite zur Build-Zeit ersetzt (define __APP_VERSION__ aus der Root-package.json).
export const APP_VERSION: string = __APP_VERSION__
